/** 一次客户联系对应一个操作标识；网络中断后复用它，服务端才能识别重试。 */
export function newFollowupOperationKey() {
  return globalThis.crypto?.randomUUID?.()
    || `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}
